import { BoxTemplatesSagaWatcher } from './BoxTemplates/services/saga';
import { UnitTemplatesSagaWatcher } from './UnitTemplates/services/saga';
import { PalletTemplatesSagaWatcher } from './PalletTemplates/services/saga';

export const templatesModuleSaga = [BoxTemplatesSagaWatcher, UnitTemplatesSagaWatcher, PalletTemplatesSagaWatcher];
